module.exports = __webpack_public_path__ + "static/img/zengjia2.59e73c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zengjia2.png
// module id = d9zf
// module chunks = 24